import { deserialize } from 'cerialize'
import { CreatorModel } from '../Contracts/ContractCreator'

export class CreativesModel {
	@deserialize public id: number
	@deserialize public description: string
	@deserialize public kind: string
	@deserialize public form: string
	@deserialize public urls: string[]
	@deserialize public external_id: string | null
	@deserialize public registered_at: string | null
	@deserialize public target_geo: string[]
	@deserialize public status: string
	@deserialize public name: string
	@deserialize public created_by_user: {
		id: number
		name: string
	}
	@deserialize public contract: {
		number: string
		contractor: CreatorModel
	}
	@deserialize public active: boolean
	@deserialize public marker?: string
	@deserialize public creative_type: string
	@deserialize public contract_contractor_id?: number
}
